export const ru = {
    'column-title-conversion': 'Конверсия',
    'column-title-cpa': 'CPА, {currency}',
    'column-title-percent-conversion': '% Конверсии',
    'goals-statistics': 'Статистика по целям'
};
